import type { Category } from 'types/dyInterfaces';

export default class CategoryModule {
  moduleEl: HTMLElement;

  constructor(context: HTMLElement) {
    window as any;
    this.moduleEl = context;

    document.addEventListener('dy:module:category', () => {
      const category: Array<Category> = window['Brooklinen'].category;
      const matchedModuleObj = category.find(
        (module) => module.general.id == this.moduleEl.dataset.dyId
      );

      if (matchedModuleObj) this.updateModule(matchedModuleObj);
    });
  }

  updateCards(cardEl: HTMLElement, card: {}, key: string, index: number) {
    const cardValue: string = card[key];

    if (cardValue == '' && key !== 'video')
      cardEl.classList.add('visibility-hidden');
    else cardEl.classList.remove('visibility-hidden');

    if (key == 'link') cardEl['href'] = cardValue;
    else if (key == 'video' || key == 'image') {
      const videoElList: NodeListOf<HTMLVideoElement> =
          this.moduleEl.querySelectorAll(`video.category__video`),
        videoEl: HTMLVideoElement = videoElList[index];

      videoEl.poster = card['image'];
      if (cardValue !== '') {
        videoEl.src = cardValue;
        videoEl.play(); // accommodates iOS low battery mode by removing inline autoplay and then manually playing
      }
    } else cardEl.innerHTML = cardValue;
  }

  setUpCategoryCards(obj: Category) {
    obj.cards.forEach((card: {}, index) => {
      const cardKeys: Array<string> = Array.from(Object.keys(card));

      cardKeys.forEach((key: keyof typeof card, i) => {
        const cardItems: string = cardKeys[i],
          cardEl: HTMLCollectionOf<Element> =
            this.moduleEl.getElementsByClassName(`category__${cardItems}`);
        if (cardEl[index])
          this.updateCards(cardEl[index] as HTMLElement, card, key, index);
      });
    });
  }

  updateDataAttr(obj: Category) {
    const { dataset } = this.moduleEl,
      header = obj.general.header.replace(/\s/g, '-').toLowerCase();

    dataset.metaSrc = 'dy';
    dataset.htId = `${header}`;
  }

  updateModule(obj: Category) {
    const { header, backgroundColor } = obj.general,
      headerEl: HTMLElement = this.moduleEl.querySelector('.h2');

    if (header !== '') headerEl.innerHTML = header;
    else headerEl.classList.add('visibility-hidden');

    this.moduleEl.parentElement.style.backgroundColor = backgroundColor;
    this.updateDataAttr(obj);
    this.setUpCategoryCards(obj);
  }
}
